(function () {
  'use strict';

  /*
   * TITANIC BRUSH CO.
   * Dynamic YouTube Mega Menu
   *
   * Long-form: newest uploads over 3 minutes
   * Shorts: newest uploads 3 minutes or under
   */

  const TBC_YOUTUBE = {
    channelId: 'UCACO66M_GrQnPSRjLjRbOcw',

    // We will add this in the next step.
    apiKey: 'AIzaSyAzPWa1-PhCkbBWtLUbpviXlR6es6yfPnk',

    longFormCount: 3,
    shortsCount: 3,

    // Current YouTube Shorts maximum duration
    shortsMaxSeconds: 180
  };

  function waitForMenu() {
    const videosContainer = document.getElementById('tbc-latest-videos');
    const shortsContainer = document.getElementById('tbc-latest-shorts');

    if (!videosContainer || !shortsContainer) {
      setTimeout(waitForMenu, 500);
      return;
    }

    if (videosContainer.dataset.tbcLoaded === 'true') {
      return;
    }

    videosContainer.dataset.tbcLoaded = 'true';

    loadTitanicYouTube(videosContainer, shortsContainer);
  }

  async function loadTitanicYouTube(videosContainer, shortsContainer) {
    if (!TBC_YOUTUBE.apiKey) {
      showSetupMessage(videosContainer, shortsContainer);
      return;
    }

    try {
      const channel = await getChannel();

      if (!channel || !channel.id) {
        throw new Error('Titanic Brush YouTube channel could not be found.');
      }

      const uploadsPlaylist =
        channel.contentDetails &&
        channel.contentDetails.relatedPlaylists &&
        channel.contentDetails.relatedPlaylists.uploads;

      if (!uploadsPlaylist) {
        throw new Error('YouTube uploads playlist could not be found.');
      }

      const uploads = await getRecentUploads(uploadsPlaylist);

      if (!uploads.length) {
        throw new Error('No recent YouTube uploads were found.');
      }

      const ids = uploads.map(item => item.videoId);

      const details = await getVideoDetails(ids);

      const uploadOrder = {};
      uploads.forEach((item, index) => {
        uploadOrder[item.videoId] = index;
      });

      details.sort((a, b) => {
        return uploadOrder[a.id] - uploadOrder[b.id];
      });

      const shorts = [];
      const longForm = [];

      details.forEach(video => {
        const seconds = isoDurationToSeconds(
          video.contentDetails && video.contentDetails.duration
        );

        const item = {
          id: video.id,
          title: decodeEntities(video.snippet.title),
          thumbnail: getBestThumbnail(video.snippet.thumbnails),
          duration: seconds
        };

        if (seconds > 0 && seconds <= TBC_YOUTUBE.shortsMaxSeconds) {
          shorts.push(item);
        } else if (seconds > TBC_YOUTUBE.shortsMaxSeconds) {
          longForm.push(item);
        }
      });

      renderLongForm(
        videosContainer,
        longForm.slice(0, TBC_YOUTUBE.longFormCount)
      );

      renderShorts(
        shortsContainer,
        shorts.slice(0, TBC_YOUTUBE.shortsCount)
      );

      const menu = document.querySelector('.tbc-youtube-menu');

if (menu) {
  menu.classList.add('tbc-loaded');
}

    } catch (error) {
      console.error('Titanic Brush YouTube menu:', error);

      videosContainer.innerHTML =
        '<div class="tbc-loading">Latest videos are having a little tea break. View them on YouTube instead.</div>';

      shortsContainer.innerHTML =
        '<div class="tbc-loading">Latest Shorts are having a little tea break. View them on YouTube instead.</div>';
    }
  }

  async function getChannel() {
  const url =
    'https://www.googleapis.com/youtube/v3/channels' +
    '?part=id,contentDetails' +
    '&id=' + encodeURIComponent(TBC_YOUTUBE.channelId) +
    '&key=' + encodeURIComponent(TBC_YOUTUBE.apiKey);

  const response = await fetch(url);

  if (!response.ok) {
    throw new Error('YouTube channel request failed.');
  }

  const data = await response.json();

  return data.items && data.items.length ? data.items[0] : null;
}

  async function getRecentUploads(playlistId) {
    const url =
      'https://www.googleapis.com/youtube/v3/playlistItems' +
      '?part=snippet,contentDetails' +
      '&playlistId=' + encodeURIComponent(playlistId) +
      '&maxResults=30' +
      '&key=' + encodeURIComponent(TBC_YOUTUBE.apiKey);

    const response = await fetch(url);

    if (!response.ok) {
      throw new Error('YouTube uploads request failed.');
    }

    const data = await response.json();

    return (data.items || [])
      .map(item => ({
        videoId:
          item.contentDetails && item.contentDetails.videoId,
        publishedAt:
          item.contentDetails && item.contentDetails.videoPublishedAt
      }))
      .filter(item => item.videoId);
  }

  async function getVideoDetails(ids) {
    if (!ids.length) {
      return [];
    }

    const url =
      'https://www.googleapis.com/youtube/v3/videos' +
      '?part=snippet,contentDetails,status' +
      '&id=' + encodeURIComponent(ids.join(',')) +
      '&key=' + encodeURIComponent(TBC_YOUTUBE.apiKey);

    const response = await fetch(url);

    if (!response.ok) {
      throw new Error('YouTube video details request failed.');
    }

    const data = await response.json();

    return (data.items || []).filter(video => {
      return (
        video.status &&
        video.status.privacyStatus === 'public' &&
        video.status.embeddable !== false
      );
    });
  }

  function renderLongForm(container, videos) {
    if (!videos.length) {
      container.innerHTML =
        '<div class="tbc-loading">More tutorials coming soon.</div>';
      return;
    }

    container.innerHTML = videos
      .map(video => {
        return `
          <a
            class="tbc-video-card"
            href="https://www.youtube.com/watch?v=${escapeHtml(video.id)}"
            target="_blank"
            rel="noopener"
            aria-label="${escapeHtml(video.title)}"
          >
            <div class="tbc-video-image">
              <img
                src="${escapeHtml(video.thumbnail)}"
                alt="${escapeHtml(video.title)}"
                loading="lazy"
              >
              <span class="tbc-play-button" aria-hidden="true"></span>
            </div>

            <span class="tbc-video-title">
              ${escapeHtml(video.title)}
            </span>
          </a>
        `;
      })
      .join('');
  }

  function renderShorts(container, videos) {
    if (!videos.length) {
      container.innerHTML =
        '<div class="tbc-loading">More quick tips coming soon.</div>';
      return;
    }

    container.innerHTML = videos
      .map(video => {
        return `
          <a
            class="tbc-short-card"
            href="https://www.youtube.com/shorts/${escapeHtml(video.id)}"
            target="_blank"
            rel="noopener"
            aria-label="${escapeHtml(video.title)}"
          >
            <div class="tbc-short-image">
              <img
                src="${escapeHtml(video.thumbnail)}"
                alt="${escapeHtml(video.title)}"
                loading="lazy"
              >
              <span class="tbc-play-button" aria-hidden="true"></span>
            </div>

            <span class="tbc-short-title">
              ${escapeHtml(video.title)}
            </span>
          </a>
        `;
      })
      .join('');
  }

  function isoDurationToSeconds(duration) {
    if (!duration) {
      return 0;
    }

    const match = duration.match(
      /PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/
    );

    if (!match) {
      return 0;
    }

    const hours = parseInt(match[1] || 0, 10);
    const minutes = parseInt(match[2] || 0, 10);
    const seconds = parseInt(match[3] || 0, 10);

    return (hours * 3600) + (minutes * 60) + seconds;
  }

  function getBestThumbnail(thumbnails) {
    if (!thumbnails) {
      return '';
    }

    return (
      (thumbnails.maxres && thumbnails.maxres.url) ||
      (thumbnails.standard && thumbnails.standard.url) ||
      (thumbnails.high && thumbnails.high.url) ||
      (thumbnails.medium && thumbnails.medium.url) ||
      (thumbnails.default && thumbnails.default.url) ||
      ''
    );
  }

  function decodeEntities(value) {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = value || '';
    return textarea.value;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function showSetupMessage(videosContainer, shortsContainer) {
    videosContainer.innerHTML =
      '<div class="tbc-loading">YouTube feed ready to connect.</div>';

    shortsContainer.innerHTML =
      '<div class="tbc-loading">YouTube feed ready to connect.</div>';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForMenu);
  } else {
    waitForMenu();
  }

  /*
   * Globo may insert the mega-menu after initial page load,
   * so watch the page for the menu appearing.
   */
  const observer = new MutationObserver(function () {
    if (
      document.getElementById('tbc-latest-videos') ||
      document.getElementById('tbc-latest-shorts')
    ) {
      waitForMenu();
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

})();